import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicInterruptDrivenIO = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Interrupt Driven I/O"
      videos={[
        "https://www.youtube.com/embed/iuOjtZlix4E",
        "https://www.youtube.com/embed/WGX_Wg79iY0"
      ]}
      takeaways={[
        { text: "Learn about different modes of transfer." },
        { text: "Understand the block diagrams." },
        { text: "Know the pros and cons of Interrupt Driven I/O." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicInterruptDrivenIO;
